import React, { useEffect, useState } from "react";
import axios from "axios";
import Hero from "../components/Hero";
import NoticeBar from "../components/NoticeBar";
import Categories from "../components/Categories";
import About from "../components/About";
import CounterSection from "../components/CounterSection";
import AffiliationSlider from "../components/AffiliationSlider";
import Features from "../components/Features";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import { normalizeHomeSettings } from "../utils/homeContent";

const API = "/api";

function Home() {
  const [homeContent, setHomeContent] = useState(() => normalizeHomeSettings({}));
  const [banners, setBanners] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    let active = true;

    const loadHomeContent = async () => {
      try {
        const [settingsRes, bannersRes] = await Promise.all([
          axios.get(`${API}/home-settings`),
          axios.get(`${API}/home-banners`),
        ]);
        const testimonialsRes = await axios.get(`${API}/student-testimonials`);

        if (!active) return;

        setHomeContent(normalizeHomeSettings(settingsRes.data));
        setBanners(Array.isArray(bannersRes.data) ? bannersRes.data : []);
        setTestimonials(Array.isArray(testimonialsRes.data) ? testimonialsRes.data : []);
      } catch {
        if (!active) return;
        setHomeContent(normalizeHomeSettings({}));
        setBanners([]);
        setTestimonials([]);
      }
    };

    loadHomeContent();

    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <Hero settings={homeContent} banners={banners} />
      <NoticeBar notices={homeContent.notices} />
      <Categories settings={homeContent} />
      <About />
      <CounterSection settings={homeContent} />
      <AffiliationSlider settings={homeContent} />
      <Testimonials testimonials={testimonials} />
      <Features settings={homeContent} />
      <Footer />
    </>
  );
}

export default Home;
